/* Accessible names for Shopify-owned elements inserted after Liquid rendering.
   Keep the widgets, their styles, and their event handlers intact. */
(() => {
  const observedRoots = new WeakSet();
  const pendingButtons = new WeakSet();
  const selector = 'iframe#PBarNextFrame, iframe[id^="web-pixel-sandbox-"], shop-follow-button';

  function nameFrame(frame) {
    if (frame.title.trim() || frame.getAttribute('aria-label')?.trim() ||
        frame.getAttribute('aria-labelledby')?.trim()) return;
    frame.title = frame.id === 'PBarNextFrame'
      ? 'Shopify theme preview toolbar'
      : 'Shopify analytics';
  }

  function nameShopGraphics(root) {
    for (const svg of root.querySelectorAll('svg')) {
      if (svg.getAttribute('aria-hidden') === 'true' ||
          svg.getAttribute('aria-label')?.trim() ||
          svg.getAttribute('aria-labelledby')?.trim()) continue;
      const title = svg.querySelector('title')?.textContent.trim();
      if (title) {
        // Preserve Shopify's localized wordmark name and expose it explicitly.
        svg.setAttribute('aria-label', title);
      } else if (!svg.hasAttribute('role')) {
        // The heart duplicates the adjacent Follow text; it is decorative.
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
      }
    }
  }

  function observeShopButton(button) {
    if (!button.isConnected) return;
    const root = button.shadowRoot;
    if (!root) {
      if (!pendingButtons.has(button)) {
        pendingButtons.add(button);
        customElements.whenDefined('shop-follow-button').then(() => {
          // The component creates its open shadow root during upgrade.
          requestAnimationFrame(() => {
            if (button.isConnected && button.shadowRoot) observeShopButton(button);
          });
        });
      }
      return;
    }
    if (observedRoots.has(root)) return;
    observedRoots.add(root);
    nameShopGraphics(root);
    // Shopify can render the wordmark again after the follow state changes.
    new MutationObserver(() => nameShopGraphics(root)).observe(root, {
      childList: true,
      subtree: true,
    });
  }

  function inspect(node) {
    if (!(node instanceof Element)) return;
    const repair = element => element.localName === 'iframe'
      ? nameFrame(element)
      : observeShopButton(element);
    if (node.matches(selector)) repair(node);
    for (const element of node.querySelectorAll(selector)) repair(element);
  }

  inspect(document.documentElement);
  // Process only added subtrees, without timers or repeated whole-page scans.
  new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) inspect(node);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
